import React from "react";
import {useGetBranchesQuery} from "../../store/api/branchApi";
import Exception from "../../components/exception/Exception";
import {useGetCitiesQuery} from "../../store/api/cityApi";
import Loader from "../../components/loader/Loader";
import { useGetUsersSelfQuery } from "../../store/api/userApi";
import { useGetAuthToken } from "../../store/api/authSlice";

interface ApplicationProviderProps {
    children?: React.ReactNode
}

const ApplicationProvider: React.FC<ApplicationProviderProps> = ({children}) => {

    const token = useGetAuthToken()
    const {isLoading:branchesLoading, isError:branchesError} = useGetBranchesQuery()
    const {isLoading:citiesLoading, isError:citiesError} = useGetCitiesQuery()
    useGetUsersSelfQuery(undefined, { skip: !token })

    if (branchesLoading || citiesLoading) return <Loader/>

    if (branchesError || citiesError) return <Exception/>

    return <>{children}</>

}

export default ApplicationProvider